import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import React, { useCallback, useState } from "react"
import { AllDepartmentsQueryVariables, useAllDepartmentsQuery } from "../../graphql"
import { DepartmentsList } from "./DepartmentsList"

export const AllDepartments: React.FC = () => {
	const [pagination, setPagination] = useState<AllDepartmentsQueryVariables["pagination"]>({ limit: 20, page: 1 })

	const [{ data, fetching, error }] = useAllDepartmentsQuery({
		variables: { pagination },
	})

	const nextPage = useCallback(() => {
		if (fetching) return

		if (data?.allDepartments.hasNextPage) {
			setPagination((prev) => ({
				...prev,
				page: (prev.page || 0) + 1,
			}))
		}
	}, [data, fetching])

	return (
		<VStack w="full" maxW="2xl" align="stretch">
			{fetching && !data?.allDepartments ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading departments</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.allDepartments.departments && data.allDepartments.departments.length ? (
				<VStack w="full" align="stretch">
					<Text>
						Showing {data.allDepartments.departments.length || 0} department
						{(data.allDepartments.departments.length || 0) > 1 ? "s" : ""}
					</Text>

					<DepartmentsList departments={data.allDepartments.departments} loadMore={nextPage} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more departments</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						Couldn&apos;t find any departments.
					</Text>
				</Center>
			)}
		</VStack>
	)
}
